/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PolicyQuery = {
    readonly _children: {
        readonly items: ReadonlyArray<{
            readonly _children?: {
                readonly items: ReadonlyArray<{
                    readonly metaTitle?: string | null;
                    readonly title?: string;
                    readonly content?: string | null;
                    readonly pageName?: string;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "PolicyQuery";
};
export type PolicyQuery$data = PolicyQuery;
export type PolicyQuery$key = {
    readonly " $data"?: PolicyQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"PolicyQuery">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PolicyQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PublishedContentConnection",
      "kind": "LinkedField",
      "name": "_children",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "PublishedContentConnection",
                  "kind": "LinkedField",
                  "name": "_children",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": null,
                      "kind": "LinkedField",
                      "name": "items",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "metaTitle",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "title",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "content",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "pageName",
                                  "storageKey": null
                                }
                              ],
                              "type": "SimplePagePublishedContent",
                              "abstractKey": null
                            }
                          ],
                          "type": "ContentPagePublishedContent",
                          "abstractKey": "__isContentPagePublishedContent"
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "type": "AboutPublishedContent",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "HomePublishedContent",
  "abstractKey": null
};
(node as any).hash = '80482574c420d1a41d2c7447854d83a6';
export default node;
